var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08586 16.4999C0.695339 16.8904 0.695339 17.5235 1.08586 17.914C1.47639 18.3045 2.1094 18.3045 2.49993 17.914L11.207 9.20696L2.49992 0.499924C2.1094 0.1094 1.47639 0.1094 1.08586 0.499924C0.695338 0.890449 0.695338 1.52346 1.08586 1.91399L8.37883 9.20696L1.08586 16.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow-right.f0a431dea33cb4ee9ee6e549e33387e9.svg";
export { ForwardRef as ReactComponent };